import TenantLogin from "@/modules/auth/views/TenantLogin.vue";
import Register from "@/modules/auth/views/Register.vue";

const route = "/auth";

export default [
  // redirect to login page
  {
    path: `${route}/login`,
    name: "auth.login",
    component: TenantLogin,
  },
  {
    path: `${route}/register`,
    name: "auth.register",
    component: Register,
  },
  {
    path: `${route}/register/:institutionSlug`,
    name: "auth.register.dedicated",
    component: Register,
  },
];
